import { useWidgetParentSize } from '@widgets/messenger/compositions/useWidgetParentSize'
import { messengerMobileWidgetShadowOffset, messengerWidgetShadowOffset } from '@widgets/messenger/const'
import { computed } from '@/composition/vue/compositionApi'

export const useWidgetShadowOffset = () => {
  const { isParentMobile } = useWidgetParentSize()
  return computed(() => (isParentMobile.value ? messengerMobileWidgetShadowOffset : messengerWidgetShadowOffset))
}
